/**
 * Resolves the display currency symbol for a catalog document.
 * 
 * Rules:
 * - Retrieved from catalog.currency (or catalog.value.currency)
 * - If field is "other" (case-insensitive), catalog.otherCurrency is used instead
 * - If "other" and no otherCurrency field exists/empty, fallback to '$'
 */
export const getCurrencySymbol = (catalog) => {
    if (!catalog) return '$';
    
    // Support raw catalog object or Redux wrapper catalog.value
    const cat = catalog?.value || catalog;
    const currency = cat?.currency;
    const otherCurrency = cat?.otherCurrency;

    if (!currency) return '$';

    if (typeof currency === 'string' && currency.toLowerCase() === 'other') {
        if (otherCurrency && typeof otherCurrency === 'string' && otherCurrency.trim() !== '') {
            return otherCurrency.trim();
        }
        return '$';
    }

    return currency;
};
